import { Component, EventEmitter, Input, Output } from '@angular/core';
import { COPYS, EMPTY_STRING, ICON_URLS } from '@app/constants';
import { AssessmentSelfManagementInformationProps } from '@app/interface/assessment-self-management-information-props.interface';
import { HtmlSanitizationService } from '@app/services/html-sanitization.service';

@Component({
  selector: 'app-assessment-self-management-information',
  templateUrl: './assessment-self-management-information.component.html',
  styleUrls: ['./assessment-self-management-information.component.scss'],
})
export class AssessmentSelfManagementInformationComponent
  implements AssessmentSelfManagementInformationProps
{
  @Input() closeOnly = false;
  @Input() showIcon = false;
  @Input() showActions = false;
  @Input() descriptionHtml = this.htmlSanitizationService.sanitize(EMPTY_STRING);
  @Input() cancelText = COPYS.Cancel;
  @Input() confirmText = COPYS.Confirm;
  @Input() informationPurpleIcon = ICON_URLS.InformationPurple;
  @Input() isLoading = false;
  @Output() cancelEvent = new EventEmitter();
  @Output() confirmEvent = new EventEmitter();

  constructor(private readonly htmlSanitizationService: HtmlSanitizationService) {}

  handleCancel() {
    this.cancelEvent.emit();
  }

  handleConfirm() {
    if (this.isLoading) {
      return;
    }
    this.confirmEvent.emit();
  }

  get confirmButtonText(): string {
    return this.isLoading ? COPYS.Loading : this.confirmText;
  }
}
